import { React, useEffect, useState } from "react";
import { RightLayoutContainer, PageTitleComp } from "../styledElements";
import { PageHeader, Row, Col } from "antd";
import HeaderNav from "../../Components/Header/Header";
import { Layout } from "antd";
import { LandingPage } from "../pageStyled";
import { Link, useNavigate } from "react-router-dom";
import Iconmoon from "../../Components/IconsFiles/icon";
import paperLoad from "../../Assets/Icons/paper-load.svg";
import paperRolling from "../../Assets/Icons/tissue-rolling.svg";
import groupSet from "../../Assets/Icons/group-set.svg";
import track from "../../Assets/Icons/track.svg";
import userM from "../../Assets/Icons/user2.svg";
import stocks from  "../../Assets/Icons/stocks.svg"
import { getWorkflowSettings } from "../../Services/workFlowSettingsServices";
import moment from "moment";
const LandingData = (props) => {
  const history = useNavigate();
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [switchDeckleApprovalFlow, setSwitchDeckleApprovalFlow] =
  useState(false);
  const [switchApprovalFlow, setSwitchApprovalFlow] = useState(false);
  const [orderManagementSettings,setOrderManagementSetting] = useState(null);

  const handleDummyOrders = async (values) => {
    const formattedValues = {
      ...values,
      date: moment().format("YYYY-MM-DD"),
      reference_number: '',
      uploadedDocsArr:[],
    };
    history("../order-entry/order-details", {
      state: {
        values: formattedValues,
        route: "add-new-so",
        isSo: true,
        soNumber: '',
        // backKey: location.state.backKey,
        uploadDocument: [], // pass the actual files
        dummyOrders: true
      },
    });
  };

useEffect (() => {

   (async () => {
        let orderMangtSettings = await getWorkflowSettings("order_management");
        
        setSwitchApprovalFlow(orderMangtSettings?.data?.approval_flow?.value);
        setOrderManagementSetting(orderMangtSettings);
        localStorage.setItem("order-management-settings", JSON.stringify(orderMangtSettings?.data));
        let deckleMangtSettings = await getWorkflowSettings("deckle_management");
        
        setSwitchDeckleApprovalFlow(
          deckleMangtSettings?.data?.approval_flow?.value
        )
       
      })();
  
},[]);


  return (
    <Layout>
      <HeaderNav />
      <RightLayoutContainer>
        <LandingPage>
          <Layout
            style={{
              backgroundColor: "#ffffff",
              paddingTop: "11px",
              paddingLeft: "16px",
              paddingRight: "2px",
            }}
          >
            <Row gutter={[16]}>
              <Col span={19}>
                <PageTitleComp className="landingHeader">
                  {userDetails ? (
                    <PageHeader
                      ghost={false}
                      title={`Hello ${userDetails.name}`}
                    ></PageHeader>
                  ) : (
                    <></>
                  )}
                </PageTitleComp>
                <div className="leftSideModules">
                  <Row>
                    {/* <Col span={6}> */}
                    {userDetails.roles.global_settings.edit ||
                    userDetails.roles.global_settings.view ? (
                      <div className="modulesListMain">
                        <Link to="/configuration/global-settings/">
                          <div className="modulesList">
                            <div className="modulesList_image">
                              <Iconmoon
                                icon="setting"
                                size={38}
                                color="#E1DFDD"
                              />
                            </div>
                            <div className="modulesList_content">
                              <span>Configurations</span>
                              <p style={{ width: "181px" }}>
                                Setup your mill configuration like machine
                                capability, product offering and customer
                                details to manage production
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ) : userDetails.roles.customer_records.edit ||
                      userDetails.roles.customer_records.view ? (
                      <div className="modulesListMain">
                        <Link to="/configuration/customer-records/">
                          <div className="modulesList">
                            <div className="modulesList_image">
                              <Iconmoon
                                icon="setting"
                                size={38}
                                color="#E1DFDD"
                              />
                            </div>
                            <div className="modulesList_content">
                              <span>Configurations</span>
                              <p style={{ width: "181px" }}>
                                Setup your mill configuration like machine
                                capability, product offering and customer
                                details to manage production
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ) : userDetails.roles.machine_records.edit ||
                      userDetails.roles.machine_records.view ? (
                      <div className="modulesListMain">
                        <Link to="/configuration/machine-records/">
                          <div className="modulesList">
                            <div className="modulesList_image">
                              <Iconmoon
                                icon="setting"
                                size={38}
                                color="#E1DFDD"
                              />
                            </div>
                            <div className="modulesList_content">
                              <span>Configurations</span>
                              <p style={{ width: "181px" }}>
                                Setup your mill configuration like machine
                                capability, product offering and customer
                                details to manage production
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ) : userDetails.roles.product_records.edit ||
                      userDetails.roles.product_records.view ? (
                      <div className="modulesListMain">
                        <Link to="/configuration/products-records/">
                          <div className="modulesList">
                            <div className="modulesList_image">
                              <Iconmoon
                                icon="setting"
                                size={38}
                                color="#E1DFDD"
                              />
                            </div>
                            <div className="modulesList_content">
                              <span>Configurations</span>
                              <p style={{ width: "181px" }}>
                                Setup your mill configuration like machine
                                capability, product offering and customer
                                details to manage production
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ) : null}

                    {/* </Col> */}
                    {userDetails.roles.order_records.edit_all ||
                    userDetails.roles.order_records.edit_own ||
                    userDetails.roles.order_records.view_all ||
                    userDetails.roles.order_records.view_own ? (
                      // <Col span={6}>
                      <div className="modulesListMain">
                        <Link to="/order-entry/order-records/">
                          <div className="modulesList">
                            <div className="modulesList_image">
                              <img src={paperLoad} alt="Order Management" />
                            </div>
                            <div className="modulesList_content">
                              <span>Order Management</span>
                              <p style={{ width: "181px" }}>
                                Create and approve Orders, prioritize urgent
                                orders and check the order progress
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ) : // </Col>
                    userDetails.roles.approve_orders.edit ? (
                      <div className="modulesListMain">
                        <Link to="/order-entry/approve-records/">
                          <div className="modulesList">
                            <div className="modulesList_image">
                              <img src={paperLoad} alt="Order Management" />
                            </div>
                            <div className="modulesList_content">
                              <span>Order Management</span>
                              <p style={{ width: "181px" }}>
                                Create and approve Orders, prioritize urgent
                                orders and check the order progress
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ) : null}
                    {/* <Col span={6}> */}
                    {userDetails.roles.job_cards.edit ||
                    userDetails.roles.job_cards.view ||
                    userDetails.roles.approve_jobcards.edit ? (
                      <div className="modulesListMain">
                        <Link to="/deckle-matching/job-cards/">
                          <div className="modulesList">
                            <div className="modulesList_image">
                              <img src={paperRolling} alt="Deckle Management" />
                            </div>
                            <div className="modulesList_content">
                              <span>Deckle Management</span>
                              <p style={{ width: "181px" }}>
                                Create job cards for production while managing
                                your trim loss and fulfilment
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ) : null}
                    {/* </Col> */}
                    {/* <Col span={6}> */}
                    {userDetails.roles.company_profile.edit ||
                    userDetails.roles.company_profile.view ||
                    userDetails.roles.plan_details_and_billing.edit ||
                    userDetails.roles.plan_details_and_billing.view ||
                    userDetails.roles.user_management.edit ||
                    userDetails.roles.user_management.view ? (
                      <div className="modulesListMain">
                        <Link to="/organization-setting/company-information/">
                          <div className="modulesList">
                            <div
                              className="modulesList_image"
                              style={{ padding: "19px" }}
                            >
                              <img src={groupSet} alt="Organization Settings" />
                            </div>
                            <div className="modulesList_content">
                              <span>Organization Settings</span>
                              <p style={{ width: "181px" }}>
                                Manage your company information, billing cycle
                                and the users granted access to the system
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ) : null}
                    {/* </Col>
                  </Row>
                  <Row>
                    <Col span={6}> */}

                    {orderManagementSettings && !orderManagementSettings?.data?.fetch_balance_quantity?.value && (userDetails.roles.production.job_cards.edit ||
                    userDetails.roles.production.job_cards.view ? (
                      <div className="modulesListMain">
                        <Link to="/production-planning/Production-job-cards">
                          <div className="modulesList">
                            <div className="modulesList_image">
                              <img src={track} alt="Production Planning" />
                            </div>
                            <div className="modulesList_content">
                              <span>Production Planning</span>
                              <p style={{ width: "181px" }}>
                                Schedule job cards for production and monitor
                                your production progress
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ) : userDetails.roles.production.jumbo_reels.edit ||
                      userDetails.roles.production.jumbo_reels.view ? (
                      <div className="modulesListMain">
                        <Link to="/production-planning/jumbo-reel-records">
                          <div className="modulesList">
                            <div className="modulesList_image">
                              <img src={track} alt="Production Planning" />
                            </div>
                            <div className="modulesList_content">
                              <span>Production Planning</span>
                              <p style={{ width: "181px" }}>
                                Schedule job cards for production and monitor
                                your production progress
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ) : userDetails.roles.production.prod_details.edit ||
                      userDetails.roles.production.prod_details.view ? (
                      <div className="modulesListMain">
                        <Link to="/production-planning/production-detail">
                          <div className="modulesList">
                            <div className="modulesList_image">
                              <img src={track} alt="Production Planning" />
                            </div>
                            <div className="modulesList_content">
                              <span>Production Planning</span>
                              <p style={{ width: "181px" }}>
                                Schedule job cards for production and monitor
                                your production progress
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ) : null)}

                    {orderManagementSettings && !orderManagementSettings?.data?.fetch_balance_quantity?.value && 
                    (userDetails.roles.inventory.stocks.edit ||
                      userDetails.roles.inventory.stocks.view) && (
                      <div className="modulesListMain">
                        <Link to="/stock-management/stock-records/">
                          <div className="modulesList">
                            <div className="modulesList_image">
                              <img src={stocks} alt="Stock Management" />
                            </div>
                            <div className="modulesList_content">
                              <span>Stocks Management</span>
                              <p style={{ width: "181px" }}>
                                Manage your work in progress and finished goods
                                inventory stock
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    )}
                    {/* </Col>
                    <Col span={6}> */}
                    <div className="modulesListMain">
                      <Link to="/profile-setting/general">
                        <div className="modulesList">
                          <div
                            className="modulesList_image"
                            style={{ padding: "21px" }}
                          >
                            <img src={userM} alt="Profile Settings" />
                          </div>
                          <div className="modulesList_content">
                            <span>Profile Settings</span>
                            <p style={{ width: "181px" }}>
                              Manage your profile settings and account password
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                    {/* </Col> */}
                  </Row>
                </div>
              </Col>
              <Col span={5}>
                <div className="rightMenuSection">
                  <PageTitleComp className="landingHeader">
                    <PageHeader
                      extra={[
                        <div className="headerAvatarTitle">
                          <div className="avatar"></div>
                          <div>
                            <span>Need product related help?</span>
                            <p>
                              <Link
                                to="/contact-us"
                                style={{ color: "#ea655b" }}
                              >
                                Ask our specialist
                              </Link>
                            </p>
                          </div>
                        </div>,
                      ]}
                    ></PageHeader>
                  </PageTitleComp>
                  <div className="rightSideModules">
                    <span>Your Modules</span>
                    <div className="rightSideModules_links">
                      {userDetails.roles.order_records.edit_own ||
                        (userDetails.roles.order_records.edit_all && (
                          <span>
                            <Link to="/order-entry/add-new-po/">
                              Create Orders
                            </Link>
                          </span>
                        ))}
                      {userDetails.roles.job_cards.edit && (
                        <span>
                          {" "}
                          <Link to="/deckle-matching/create-new-job-cards/">
                            Create Job Cards
                          </Link>
                        </span>
                      )}
                      {userDetails.roles.user_management.edit &&
                        userDetails.role_type !== "BASIC" && (
                          <span>
                            {" "}
                            <Link to="/organization-setting/user-management/invite-user">
                              Add a user
                            </Link>
                          </span>
                        )}
                      { (userDetails.roles.approve_orders.edit && switchApprovalFlow) && ( <span>
                        {" "}
                        <Link to="/order-entry/approve-records/">
                          Approve Orders
                        </Link>
                      </span> )}
                      { (userDetails.roles.approve_jobcards.edit && switchDeckleApprovalFlow) && ( <span>
                        <Link to="/deckle-matching/job-cards/">Approve Job Cards</Link>
                      </span> )}
                      {/* {userDetails.roles.approve_jobcards.edit && ( */}
                        <span>
                        {/* onClick={() => handleDummyOrders() }> */}
                          <Link
                            to={{
                              pathname: "/order-entry/order-details",
                            }}

                            state={{
                              values: {
                                date: moment().format("YYYY-MM-DD"),
                                reference_number: '',
                                uploadedDocsArr: []
                              },
                              route: "add-new-so",
                              isSo: true,
                              soNumber: '',
                              // backKey: location.state.backKey,
                              uploadDocument: [], // pass the actual files
                              dummyOrders: true
                            }}

                          >
                            Create Dummy Job Cards
                          </Link>
                        </span>
                      {/* )} */}
                      {(userDetails.roles.approve_jobcards.edit || userDetails.roles.approve_jobcards.view || userDetails.roles.job_cards.edit || userDetails.roles.job_cards.view) &&
                        <span>
                          <Link
                            to={{
                              pathname: "/deckle-matching/job-card-summary-report",
                            }}
                            state={{ isADD: true,dummyOrders:true }}
                          >
                            Create Report
                          </Link>
                        </span>
                      }
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Layout>
        </LandingPage>
      </RightLayoutContainer>
    </Layout>
  );
};
export default LandingData;